import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AttendanceService } from 'src/app/services/attendance.service';
import { CourseUnitsService } from 'src/app/services/course-units.service';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { UtilityService } from '../../../services/utility.service'
import * as _ from 'lodash';

@Component({
  selector: 'app-allotment-confirmation',
  templateUrl: './allotment-confirmation.component.html',
  styleUrls: ['./allotment-confirmation.component.scss']
})
export class AllotmentConfirmationComponent implements OnInit {
  dueDate;
  disabled = true
  date: any;
  unitList: any = [];
  courseUnitId
  unitId
  loading
  unitListDisplay: boolean = false
  isEdit: boolean = false
  isDateDisable: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<AllotmentConfirmationComponent>,
    public _attendanceService: AttendanceService,
    public _courseUnitService: CourseUnitsService,
    public _utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this._courseUnitService.unitListObservable().subscribe((unitList) => {
      console.log("unit list in model");
      this.unitList = unitList
      console.log("unit list in model =====> ", this.unitList);
    })
  }

  ngOnInit() {
    console.log("this.data in AllotmentConfirmationComponent", this.data);
    if (this.data && this.data.date) {
      this.date = this.data.date
      this.courseUnitId = this.data.courseDetails
      this.disabled = false
      this.unitListDisplay = this.data.unitList
      console.log("Hello here is Unit List ==>", this.unitListDisplay)
      delete this.data.unitList
    }
    if (this.data.isAdd) {
      this.isEdit = false
    } else {
      this.isEdit = true
    }
    if (this.data.userRole == 'admin') this.isDateDisable = false
    else if (this.data.userRole == 'trainer') this.isDateDisable = true

  }
  dateSelected(event) {
    this.dueDate = event
    console.log("event", event, "dueDate", this.dueDate);
    this.disabled = false
  }

  dateFilter = (d: Date) => {
    console.log("this is the job date list array", this.data.jobDatesList, this.date);

    // if (this.data && this.data.isEdit) {
    //   let index = this.data.jobDatesList.findIndex((x) => x.date == this.date)
    //   console.log("here to console index", index);
    //   this.data.jobDatesList.splice(index, 1)
    // }

    console.log("after removed data", this.data.jobDatesList);

    const arrayListDate = this.data.jobDatesList.map((o) => {
      if (o.date != this.date)
        return new Date(o.date).valueOf()
    })
    console.log("arrayListDate-------->", arrayListDate);
    return arrayListDate.indexOf(d.valueOf()) == -1;
  };


  dateChangeEvent(event) {
    this.data['date'] = event
    this.disabled = false
  }

  changedUnit(event) {
    console.log("when change the unit", event);
    this.data['courseDetails'] = event.value
  }

  confirm(msg) {
    console.log("hello here is the date ===>", this.dueDate)
    if (msg == 'allocate') {
      console.log("hello here is the allotment data 11")
      this.dialogRef.close(this.dueDate)
    } else this.dialogRef.close('noData')
  }

  submit(msg) {

    if (this.data.jobDatesList) delete this.data.jobDatesList


    if (msg == 'save') {
      this.loading = true

      console.log("this.data when click on save", msg);
      this._attendanceService.editJobDatesList(this.data).subscribe(res => {
        if (res == undefined) return
        else {
          this.loading = false
          console.log("what response get---->", res);
          this.dialogRef.close({ attendance: res, date: this.data.date })
        }
      })
    }
    else if (msg == 'cancle') {
      let data = 'day'
      this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, data)
        .afterClosed().subscribe(res => {
          console.log("what is the res of delete model", res);
          if (res == undefined) return
          else if (res == 'yes') {
            console.log("here the day will be deleted", this.data);

            this._attendanceService.deleteRegisterDay(this.data).subscribe((res) => {
              console.log("response of delete day", res);
              res['deleted'] = true
              this.dialogRef.close(res)
            }, err => {
              console.log("error while delete day", err);
              this.dialogRef.close(err)
            })


          } else {
            console.log("here the day can not be deleted");

          }

        })

    }
  }

}
